/**
 * Green Flag — AfterEventMatchingCard
 *
 * Tells an attendee that matching opens after the event, the way the reminder
 * email's "Matching Form" section does, and points them at their profile.
 */

import { Box, Flex, Heading, Link, Text } from "@chakra-ui/react";
import { useId } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Icon } from "../Icon/Icon";

export function AfterEventMatchingCard() {
  const headingId = useId();
  return (
    <Box
      as="section"
      aria-labelledby={headingId}
      bg="greenLight.subtle"
      borderRadius="lg"
      p="1rem"
    >
      <Flex gap="0.75rem" align="flex-start">
        <Flex
          boxSize="2rem"
          borderRadius="full"
          bg="bg.brandSoft"
          color="fg.onTint"
          align="center"
          justify="center"
          flexShrink={0}
        >
          <Icon name="spark-filled" boxSize="14px" />
        </Flex>
        <Box>
          <Heading as="h2" id={headingId} textStyle="sectionHeading">
            After the event
          </Heading>
          <Text textStyle="body" mt="0.25rem">
            Match online with the people you met. If there's a mutual Spark,
            you can connect. Set up your profile now so you're ready.
          </Text>
          <Link
            asChild
            textStyle="labelStrong"
            color="fg.onTint"
            textDecoration="underline"
            mt="0.5rem"
          >
            <RouterLink to="/settings/profile">Set up your profile</RouterLink>
          </Link>
        </Box>
      </Flex>
    </Box>
  );
}
